/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CommsIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CommsIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CommsIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CommsIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-MwvIX': alignSelf,'--mt-2-MwvIX': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-MwvIX': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-MwvIX': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-MwvIX': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-MwvIX': opacity,'--w-10-MwvIX': typeof width === 'number' ? `${width}px` : width,'--h-11-MwvIX': typeof height === 'number' ? `${height}px` : height,'--f-12-MwvIX': fill,'--a-7-MwvIX': isAnimated ? animation : "none",'--sd-8-MwvIX': isAnimated ? strokeDashoffset : 0,'--sd-9-MwvIX': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2CommsIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.653 3.984c0 .473.384.857.857.857h1.898v1.036c0 .342.382.546.666.356l2.09-1.392h.979A.857.857 0 0012 3.984V.857A.857.857 0 0011.143 0H5.51a.857.857 0 00-.857.857v3.127zM7.3 9.429h3.415c.71 0 1.286-.576 1.286-1.286V6.857a.857.857 0 10-1.714 0v.857H1.714V2.571h.857a.857.857 0 000-1.714H1.286C.576.857 0 1.433 0 2.143v6c0 .71.576 1.286 1.286 1.286H4.7l-.46 1.285H3.43a.643.643 0 100 1.286H8.57a.643.643 0 000-1.286H7.76l-.46-1.285z"
 style={{'--f-12-MwvIX': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}